<template>
    <div class="section-title-box">
        <p class="main">{{main}}</p>
        <p class="sub">{{sub}}</p>
    </div>
</template>
<script>
export default {
    props: {
        main: {
            type: String,
            default: ''
        },
        sub: {
            type: String,
            default: ''
        }
    }
}
</script>
<style lang="scss" scoped>
.section-title-box{
    padding: 38px 0px 30px;
    .main{
        font-size:18px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(39,39,39,1);
        line-height:25px;
    }
    .sub{
        margin-top: 3px;
        font-size:10px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(39,39,39,1);
        line-height:14px;
    }
}
</style>